import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';
import { Suspense } from 'react';
import { GLOBAL_SEARCH_BE_CONFIG } from '~/components/GlobalHeader/Learner/config/constants';
import { DYNAMIC_REMOTES } from '~/config/app.constants';
import ErrorBoundaryWrapperHeader from '../ErrorBoundary';
import SemanticSearchLoader from '../SemanticSearchLoader';

const Search = () => (
  <ErrorBoundaryWrapperHeader config={GLOBAL_SEARCH_BE_CONFIG}>
    <Suspense fallback={<SemanticSearchLoader showSearch />}>
      <LoadRemote
        lazy={false}
        remote={DYNAMIC_REMOTES.GLOBAL_SEMANTIC_SEARCH}
        loader={<SemanticSearchLoader showSearch />}
        showSearch
      />
    </Suspense>
  </ErrorBoundaryWrapperHeader>
);

export default Search;
